var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page project-config"},[_c('b-container',[_c('b-row',[_c('b-col',{attrs:{"cols":"6","offset":"3"}},[_c('div',{staticClass:"panel"},[_c('k-layout-config-form')],1)])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }